import React from 'react'
/**

This is mostly for docuemntation.
It provives specific hooks for things that are positionable

*/

export const Positioner = props => {
  const { className, ...rest } = props
  return (
    <div className={`pos ${className || ''}`} {...rest}>
      {props.children}
    </div>
  )
}
